import React from 'react';

import Styled from 'styled-components';

import logo from '../images/alpha-logo.png';

import config from '../config';

const SimpleHeader = () => {
  return (
    <Wrapper>
      <img src={logo} alt="" />
      <a
        style={{ color: '#555', textDecoration: 'none' }}
        href={config.phoneNumberHref}
      >
        {config.phoneNumber}
      </a>
    </Wrapper>
  );
};

const Wrapper = Styled.div`
  box-sizing: border-box;
  background: white;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
  -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.25);
  z-index: 10000;

  a {
    height: 100%;
    background-color: #3676D9;
    background-color: #F0662F;
    color: #FFF !important;
    padding: 6px 18px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    transition: all .3s ease;

    &:hover {
      background-color: #d35b32;
    }
  }
`;

export default SimpleHeader;
